/* eslint-disable no-plusplus */
import React from "react";

// Função que cria um array de tamanho "count" com o elemento "component"
const criarArrayDeComponentes = <T extends React.ReactNode>(
  component: T,
  count: number
): T[] => {
  return Array.from({ length: count }, () => component);
};

// Hook personalizado
const useRepetirComponente = <T extends React.ReactNode>(
  component: T,
  count: number
): T[] => {
  const repeatedComponents = criarArrayDeComponentes(component, count);
  return repeatedComponents;
};

export default useRepetirComponente;
